import { useMutation } from '@tanstack/react-query';

import submitSupplierApplication from '../api/submitSupplierApplication';
import { SupplierApplicationFormData } from '../model/schema';

interface MutationVariables {
  formData: SupplierApplicationFormData;
  catalogFiles: File[];
  photoFiles: File[];
}

/**
 * Mutation hook for submitting the supplier application form.
 */
const useSupplierApplication = () => {
  return useMutation({
    mutationFn: ({ formData, catalogFiles, photoFiles }: MutationVariables) =>
      submitSupplierApplication({ formData, catalogFiles, photoFiles })
  });
};

export default useSupplierApplication;
